import React from "react";
import PropTypes from "prop-types";

import Form from "components/Form";

import { useFieldDetailsForm } from "./hooks";
import {
  Button,
  DynamicField,
  FormCheckbox,
  FormDropdown,
  FormText,
  Modal,
} from "..";

export function FieldDetailsModal({
  loading,
  field,
  title,
  subtitle,
  onSave,
  onClose,
}) {
  const { formProps, description, required, isValid, onSubmit, defaultField } =
    useFieldDetailsForm(field, onSave);

  return (
    <Modal
      style={{ maxWidth: "500px" }}
      isModalOpen
      data-test="field-details-modal"
      onClose={onClose}
    >
      <Modal.Header
        style={{ color: "#AAAAAA" }}
        onClose={onClose}
        subtitle={subtitle}
      >
        {title}
      </Modal.Header>
      <Modal.Body scrolling>
        <Form id="fieldDetailsForm" {...formProps} onSubmit={onSubmit}>
          <FormText
            id="description"
            name="Field Description"
            value={description}
            required={false}
          />
          {defaultField.isCheckbox ? (
            <FormDropdown {...defaultField} />
          ) : (
            <DynamicField field={defaultField} />
          )}
          <FormCheckbox id="required" name="Required field" value={required} />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          content="Cancel"
          type="button"
          onClick={onClose}
          disabled={loading}
        />
        <Button
          positive
          content="Save"
          type="submit"
          form="fieldDetailsForm"
          loading={loading}
          disabled={!isValid || loading}
        />
      </Modal.Footer>
    </Modal>
  );
}

FieldDetailsModal.propTypes = {
  loading: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  field: PropTypes.shape({
    description: PropTypes.string,
    required: PropTypes.bool,
    defaultValue: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.instanceOf(Date),
    ]),
  }).isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

FieldDetailsModal.defaultProps = {
  loading: false,
  title: "Edit Field Details",
  subtitle: "",
};
export default FieldDetailsModal;
